/**
 * Single source of truth for all US onboarding analytics event names.
 *
 * The `us` jurisdiction is baked into the event name (not a property) because
 * onboarding steps are expected to differ per jurisdiction.
 */

export const US_ONBOARDING_EVENTS = {
  STARTED: 'us_onboarding_started',
  STEP_VIEWED: 'us_onboarding_step_viewed',
  STEP_STARTED: 'us_onboarding_step_started',
  STEP_COMPLETED: 'us_onboarding_step_completed',
  STEP_SKIPPED: 'us_onboarding_step_skipped',
  COMPLETED: 'us_onboarding_completed',
  JOURNEY_SELECTED: 'us_onboarding_journey_selected',
  LEARN_MORE_CLICKED: 'us_onboarding_learn_more_clicked',
} as const;

/**
 * Flat array of every US onboarding event name. The hook spec
 * (`use-us-onboarding-analytics.spec.ts`) iterates this to assert each name is
 * dispatched by at least one `useUsOnboardingAnalytics` method.
 */
export const ALL_US_ONBOARDING_EVENT_NAMES =
  Object.values(US_ONBOARDING_EVENTS);
